import { DataSource } from '@angular/cdk/collections';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Ope } from 'src/app/models/Ope';
import { OpeEspVtePit } from 'src/app/models/OpeEspVtePit';
import { OpePit } from 'src/app/models/OpePit';
import { OpePublUpdate } from 'src/app/models/OpePublUpdate';
import { OptionCreateDto } from 'src/app/models/OptionCreateDto';
import { OptionFreeDto } from 'src/app/models/OptionFreeDto';
import { OptionResponseDto } from 'src/app/models/OptionResponseDto';
import { Publication } from 'src/app/models/Publication';
import { renewOption } from 'src/app/models/renwewOption';
import { SearchOpeCriteria } from 'src/app/models/SearchOpeCriteria';
import { SearchPitOpeCriteria } from 'src/app/models/SearchPitOpeCriteria';
import { vignetteOpe } from 'src/app/models/vignetteOpe';
import { vignetteOpePit } from 'src/app/models/vignetteOpePit';
import { Doc } from 'src/domain/doc';
import { DocBiPlan } from 'src/domain/docBiPlan';
import { DocBiPlanDto } from 'src/domain/docBiPlanDto';
import { DocPit } from 'src/domain/docPit';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PituploadService {

  BASE_PATH_OPE_DOCS= "/docs/ope-doc/";
  BASE_PATH_DOCS_VT= "/docs_vt";
  BASE_PATH_VIGNETTE_FIRST="/firstvignette";
  BASE_PATH_VIGNETTE="/vignettes";
  BASE_PATH_DOCS_VT_FILE="/docs/ope-doc/docs_vt_file/";

  BASE_PATH_OPEBYCRITERIA_DOCS="/docs/ope-pit/all-ope-pit-criteria";
  BASE_PATH_OPEUPDATE_DOCS="/docs/ope-pit/update";
  BASE_PATH_PUBLICATIONBYID="/docs/ope-publ/get-by-ope-num/";
  BASE_PATHPUBUPDATE = "/docs/ope-publ/update";
  BASE_PATH_ESPVTE = "/docs/esp-vte/";
  BASE_PATH_OPE_DOCS_VIT = "/docs/ope-vt/";
  BASE_PATH_OPE_BI_PLAN = "/docs/bi-plan-pit/";
  BASE_PATH_BI_PLAN="/docs/bi-pit/";
  BASE_PATH_OPE_BI_PLAN_DELETE = "/docs/bi-plan-pit/delete";
  BASE_PATH_OPE_BI_PLAN_UPDATE = "/docs/bi-plan-pit/update";
  BASE_PATH_OPE_BI_PLAN_PATCH = "/docs/bi-pit/update";
  BASE_PATH_OPE_BI_PLAN_PUB_ALL_WEB = "/docs/ope-pit/update-all-bi-web";
  BASE_PATH_OPE_BI_PLAN_PUB_ALL_EXT = "/docs/ope-pit/update-all-bi-ext";
  BASE_PATH_OPE_DOCS_VIT_DELETE = "/docs/ope-vt/delete";
  BASE_PATH_OPE_DOCS_VIT_UPDATE = "/docs/ope-vt/update";
  BASE_PATH_ESPVTEUPDATE = "/docs/esp-vte/update";
  DELETE_ACTION="delete";
  UPDATE_ACTION="update";

  errorMessage!: string;

  constructor(private readonly http: HttpClient) { }
  
  getOpebyCriteria = (filtre: SearchPitOpeCriteria, role: string,page:number, rows:number): Observable<DataSource<OpePit>> => {
  
      let urlRecherche = this.BASE_PATH_OPEBYCRITERIA_DOCS;
      const url = `${environment.host.domaineEchonet + urlRecherche}?`;
      return this.http.get<DataSource<OpePit>>(url, { params: this.ToHttpParams(filtre, page, rows) });
      
  }

  updatePubPit(body: OpePit): Observable<any> {
      const url = `${environment.host.domaineEchonet + this.BASE_PATH_OPEUPDATE_DOCS}`;
  
      // let headers = new HttpHeaders({ 'accept': '*/*'});
      let headers = new HttpHeaders({ 'accept': '*/*' });
  
      return this.http.post<OpePit>(url, body, { headers: headers });
  }
  
  deleteMedia(body: vignetteOpePit): Observable<vignetteOpePit> {
      const url = `${environment.host.domaineEchonet + this.BASE_PATH_OPE_DOCS+ this.DELETE_ACTION}`;
  
      // let headers = new HttpHeaders({ 'accept': '*/*'});
      let headers = new HttpHeaders({ 'accept': '*/*' });
  
      return this.http.post<vignetteOpePit>(url, body, { headers: headers });
  }

  updateMedia(body: any): Observable<vignetteOpePit> {
      const url = `${environment.host.domaineEchonet + this.BASE_PATH_OPE_DOCS+ this.UPDATE_ACTION}`;
  
      // let headers = new HttpHeaders({ 'accept': '*/*'});
      let headers = new HttpHeaders({ 'accept': '*/*' });
  
      return this.http.post<vignetteOpePit>(url, body, { headers: headers });
  }
  
  updateUrls(body: OpePit): Observable<any> {
      const url = `${environment.host.domaineEchonet + this.BASE_PATH_OPEUPDATE_DOCS}`;
  
      // let headers = new HttpHeaders({ 'accept': '*/*'});
      let headers = new HttpHeaders({ 'accept': '*/*' });
  
      return this.http.post<OpePit>(url, body, { headers: headers });
  }

  updatePublication(body: any): Observable<any> {
      const url = `${environment.host.domaineEchonet + this.BASE_PATHPUBUPDATE}`;
  
      // let headers = new HttpHeaders({ 'accept': '*/*'});
      let headers = new HttpHeaders({ 'accept': '*/*' });
  
      return this.http.post<OpePublUpdate>(url, body, { headers: headers });
  }
  
  updateEspVte(body: any): Observable<OpeEspVtePit> {
      const url = `${environment.host.domaineEchonet + this.BASE_PATH_ESPVTEUPDATE}`;
  
      // let headers = new HttpHeaders({ 'accept': '*/*'});
      let headers = new HttpHeaders({ 'accept': '*/*' });
  
      return this.http.post<OpeEspVtePit>(url, body, { headers: headers });
  }

  deleteDocVit(body: any): Observable<DocPit> {
      const url = `${environment.host.domaineEchonet + this.BASE_PATH_OPE_DOCS_VIT_DELETE}`;
  
      // let headers = new HttpHeaders({ 'accept': '*/*'});
      let headers = new HttpHeaders({ 'accept': '*/*' });
  
      return this.http.post<DocPit>(url, body, { headers: headers });
  }

  updateDocPit(body: any): Observable<DocPit> {
      const url = `${environment.host.domaineEchonet + this.BASE_PATH_OPE_DOCS_VIT_UPDATE}`;
  
      // let headers = new HttpHeaders({ 'accept': '*/*'});
      let headers = new HttpHeaders({ 'accept': '*/*' });
  
      return this.http.post<DocPit>(url, body, { headers: headers });
  }

  patchPubBiPlan(body: any): Observable<DocBiPlanDto> {
      const url = `${environment.host.domaineEchonet + this.BASE_PATH_OPE_BI_PLAN_PATCH}`;
  
      // let headers = new HttpHeaders({ 'accept': '*/*'});
      let headers = new HttpHeaders({ 'accept': '*/*' });
  
      return this.http.patch<DocBiPlanDto>(url, body, { headers: headers });
  }

  patchBiPlanAllPubWEB(body: any): Observable<any> {
      const url = `${environment.host.domaineEchonet + this.BASE_PATH_OPE_BI_PLAN_PUB_ALL_WEB}`;
  
      // let headers = new HttpHeaders({ 'accept': '*/*'});
      let headers = new HttpHeaders({ 'accept': '*/*' });
  
      return this.http.post<any>(url, body, { headers: headers });
  }

  patchBiPlanAllPubEXT(body: any): Observable<any> {
      const url = `${environment.host.domaineEchonet + this.BASE_PATH_OPE_BI_PLAN_PUB_ALL_EXT}`;
  
      // let headers = new HttpHeaders({ 'accept': '*/*'});
      let headers = new HttpHeaders({ 'accept': '*/*' });
  
      return this.http.post<any>(url, body, { headers: headers });
  }

  deleteBiPlan(body: any): Observable<any> {
      const url = `${environment.host.domaineEchonet + this.BASE_PATH_OPE_BI_PLAN_DELETE}`;
  
      // let headers = new HttpHeaders({ 'accept': '*/*'});
      let headers = new HttpHeaders({ 'accept': '*/*' });
  
      return this.http.post<any>(url, body, { headers: headers });
  }

  updateBiPlanPit(body: any): Observable<any> {
      const url = `${environment.host.domaineEchonet + this.BASE_PATH_OPE_BI_PLAN_UPDATE}`;
  
      // let headers = new HttpHeaders({ 'accept': '*/*'});
      let headers = new HttpHeaders({ 'accept': '*/*' });
  
      return this.http.post<any>(url, body, { headers: headers });
  }
  


  public ToHttpParams(request: any | null | undefined, page: number, size: number): HttpParams {
    
        let httpParams = new HttpParams();
       
        if(request != null && request != undefined){
        Object.keys(request).forEach((key) => {
    
          if (request[key]) {
    
            httpParams = httpParams.append(key, request[key]);
          }
        });
      }
        httpParams = httpParams.append("page", page);
        httpParams = httpParams.append("size", size);
        
        return httpParams;
    
      }

  getDocumentsBynumOpe(data: number): Observable<DocPit>{
      const url = environment.host.domaineEchonet;
      return this.http.get<DocPit>(url+this.BASE_PATH_OPE_DOCS_VIT+data);
  }

  getBiPlanByNumOpe(data: number): Observable<DocBiPlanDto[]>{
      const url = environment.host.domaineEchonet;
      return this.http.get<DocBiPlanDto[]>(url+this.BASE_PATH_BI_PLAN+data);
  }

  getPublicationOpe =(numOpe: number): Observable<Publication[]> => {
          
          const url = `${environment.host.domaineEchonet + this.BASE_PATH_PUBLICATIONBYID}`;
          return this.http.get<Publication[]>(url+numOpe);
  
  }

  getEspVte =(numOpe: number): Observable<OpeEspVtePit> => {
          
          const url = `${environment.host.domaineEchonet + this.BASE_PATH_ESPVTE}`;
          return this.http.get<OpeEspVtePit>(url+numOpe);
  
  }

  
  getFirVignetteBynumOpe(data: number): Observable<vignetteOpePit[]>{
        const url = environment.host.domaineEchonet;
        return this.http.get<vignetteOpePit[]>(url+this.BASE_PATH_OPE_DOCS+data);
  }
}